module.exports = __webpack_public_path__ + "static/media/iconAbsencesActive.a8daab7d.svg";